import React from 'react';
import ReactDOM from 'react-dom';

import { useNavigate } from 'react-router-dom';
import styles from '../ListingScore.module.css';

const AsinNotFoundModal = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleCreateNewListing = () => {
        onClose();
        navigate('/single-listing-generator');
    };

    return ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.asinNotFoundModal} onClick={(e) => e.stopPropagation()}>

                <button className={styles.modalCloseButton} onClick={onClose}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
                    </svg>
                </button>

                <div className={styles.modalDocumentIcon}>
                <svg width="359" height="337" viewBox="0 0 359 337" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_147_32)">
                    <g clip-path="url(#clip0_147_32)">
                    <rect x="98.7043" y="73.4229" width="125.444" height="169.077" rx="10.9082" transform="rotate(-13.1732 98.7043 73.4229)" fill="white"/>
                    <rect x="108.534" y="79.5244" width="109.082" height="76.3574" rx="5.4541" transform="rotate(-13.1732 108.534 79.5244)" fill="#E5EDF3"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M158.788 77.0051L169.404 74.5211C171.477 74.036 173.493 75.4657 173.747 77.6064L177.307 107.432C177.524 109.256 176.364 110.926 174.599 111.339L170.56 112.284C168.796 112.697 167.019 111.718 166.403 109.995L156.271 81.7071C155.538 79.6785 156.712 77.4909 158.788 77.0051ZM174.065 118.367C177.853 117.481 181.648 119.867 182.544 123.698C183.441 127.529 181.099 131.351 177.311 132.238C173.523 133.124 169.728 130.738 168.832 126.907C167.936 123.079 170.278 119.254 174.065 118.367Z" fill="white"/>
                    <rect x="129.043" y="167.149" width="109.082" height="4.73346" rx="2.36673" transform="rotate(-13.1732 129.043 167.149)" fill="#E5EDF3"/>
                    <rect x="132.13" y="180.34" width="70.9491" height="4.73346" rx="2.36673" transform="rotate(-13.1732 132.13 180.34)" fill="#E5EDF3"/>
                    <rect x="135.218" y="193.531" width="97.9471" height="4.73346" rx="2.36673" transform="rotate(-13.1732 135.218 193.531)" fill="#E5EDF3"/>
                    </g>
                    <rect x="99.1139" y="73.6771" width="124.763" height="168.395" rx="10.5673" transform="rotate(-13.1732 99.1139 73.6771)" stroke="#D0E7FF" strokeWidth="0.681762"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_147_32" x="-2.19647" y="-56.0659" width="362.477" height="395.017" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feMorphology radius="9.54467" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_147_32"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="45.6781"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.470588 0 0 0 0 0.701961 0 0 0 0 0.952941 0 0 0 0.08 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_147_32"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_147_32" result="shape"/>
                    </filter>
                    <clipPath id="clip0_147_32">
                    <rect x="98.7043" y="73.4229" width="125.444" height="169.077" rx="10.9082" transform="rotate(-13.1732 98.7043 73.4229)" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
                </div>

                <div className={styles.modalContent}>
                    <div className={styles.modalHeading}>Oops...</div>
                    <div className={styles.modalMessage}>
                        The ASIN entered does not exist.
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default AsinNotFoundModal;

